import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { MapView } from './components/Map/MapView';
import { FilterPanel } from './components/Filters/FilterPanel';
import { CartDrawer } from './components/Cart/CartDrawer';
import { MobileFilterButton } from './components/Filters/MobileFilterButton';
import { MobileCartButton } from './components/Cart/MobileCartButton';
export function App() {
  const [showFilters, setShowFilters] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    division: '',
    district: '',
    upazila: '',
    mouja: '',
    sheetNo: ''
  });
  // Show cart automatically when items are added
  useEffect(() => {
    if (cartItems.length > 0 && !showCart) {
      // Optional: auto-show cart when first item is added
      // setShowCart(true);
    }
  }, [cartItems, showCart]);
  const addToCart = khatian => {
    // Check if item already exists in cart
    if (!cartItems.some(item => item.id === khatian.id)) {
      setCartItems([...cartItems, khatian]);
      // Show cart when item is added
      setShowCart(true);
    }
  };
  const removeFromCart = khatianId => {
    setCartItems(cartItems.filter(item => item.id !== khatianId));
  };
  const clearCart = () => {
    setCartItems([]);
  };
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };
  const toggleCart = () => {
    setShowCart(!showCart);
  };
  return <div className="flex flex-col h-screen w-full bg-gray-50" data-id="element-0">
      <Header cartCount={cartItems.length} onCartClick={toggleCart} data-id="element-1" />
      <div className="flex flex-1 relative overflow-hidden" data-id="element-2">
        {/* Desktop Filter Panel - Always visible */}
        <div className="hidden md:block w-80 bg-white shadow-md z-10" data-id="element-3">
          <FilterPanel selectedFilters={selectedFilters} onFilterChange={setSelectedFilters} data-id="element-4" />
        </div>
        {/* Mobile Filter Panel - Overlay */}
        <div className={`md:hidden fixed inset-0 bg-gray-800 bg-opacity-75 z-20 ${showFilters ? 'block' : 'hidden'}`} onClick={toggleFilters} data-id="element-5" />
        <div className={`md:hidden fixed inset-y-0 left-0 w-80 max-w-[80vw] bg-white shadow-xl z-30 ${showFilters ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out`} data-id="element-6">
          <FilterPanel selectedFilters={selectedFilters} onFilterChange={setSelectedFilters} onClose={toggleFilters} data-id="element-7" />
        </div>
        {/* Map View - Main Content */}
        <div className="flex-1" data-id="element-8">
          <MapView selectedFilters={selectedFilters} addToCart={addToCart} data-id="element-9" />
        </div>
        {/* Cart Drawer */}
        <CartDrawer isOpen={showCart} onClose={toggleCart} items={cartItems} onRemove={removeFromCart} onClear={clearCart} data-id="element-10" />
      </div>
      {/* Mobile Action Buttons */}
      <div className="md:hidden fixed bottom-4 left-4 z-10" data-id="element-11">
        <MobileFilterButton onClick={toggleFilters} data-id="element-12" />
      </div>
      <div className="md:hidden fixed bottom-4 right-4 z-10" data-id="element-13">
        <MobileCartButton onClick={toggleCart} count={cartItems.length} data-id="element-14" />
      </div>
    </div>;
}